
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  layout: 'clean'
})
export default class GuildAgreement extends Vue {
  iframeheight: string = '100vh'

  get iframeHeight() {
    return {
      height: this.iframeheight
    }
  }

  get htmlSrc() {
    return `${process.env.static}/protocol/guild_pc.html?v=${process.env.version}`
  }

  handleMessage(e) {
    if (e.data.typeAction === 'iframeHeight') {
      if (!e.data.height) return
      this.iframeheight = `${e.data.height}px`
    }
  }

  created() {
    window.addEventListener('message', this.handleMessage)
  }

  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  }
}
